



























import { getPaginatedEntries } from '@bkwld/cloak/services/craft.coffee'
import getPaginatedCategoriesQuery from '~/queries/get-paginated-category-entries.gql'
import getPaginatedEntriesQuery from '~/queries/get-paginated-entries.gql'
import ArticleCard from '/components/globals/cards/article'
import PressReleaseCard from '/components/globals/cards/press-release'
import InTheNewsCard from '/components/globals/cards/in-the-news'

export default

	props:
		section: String
		type: String

		category: String

		showTitle:
			type: Boolean
			default: false

		pagination:
			type: String
			default: '12'

		# prevent the load more button
		# if the component using this is
		# rendering it's own button
		noLoadMore:
			type: Boolean
			default: false

	components: {
		ArticleCard,
		PressReleaseCard,
		InTheNewsCard
	}

	data: ->
		entries: []
		hasMore: false
		page: 0
		button:
			label: 'Load More'

	# Fetch entries
	fetch: ->

		{ entries: newEntries, hasMore } =  await getPaginatedEntries
			query: getPaginatedCategoriesQuery
			variables:
				section: @section
				type: @type
				category: parseInt @category
				limit: parseInt @pagination
				offset: @page * @pagination
				nextOffset: (@page + 1) * @pagination

		@entries = [ ...@entries, ...newEntries ]
		@hasMore = !!hasMore

	computed:

		query: -> if @category then getPaginatedCategoriesQuery else getPaginatedEntriesQuery

		# Build the list of entries and render the correct card
		_entries: -> @entries.map (item, index) =>

			switch item.__typename
				when 'articles_template_Entry'
					{ ...item, component: 'ArticleCard'}

				when 'pressReleases_template_Entry'
					{ ...item, component: 'PressReleaseCard'}

				when 'inTheNews_news_Entry'
					{ ...item, component: 'InTheNewsCard'}

	watch:

		# watch the page and query for more entries
		page: -> @$fetch()

